import { render } from "./BarcodeReader.vue?vue&type=template&id=63e87960&scoped=true"
import script from "./BarcodeReader.vue?vue&type=script&lang=js"
export * from "./BarcodeReader.vue?vue&type=script&lang=js"

import "./BarcodeReader.vue?vue&type=style&index=0&id=63e87960&scoped=true&lang=css"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e87960"]])

export default __exports__